import { CurrentLandingTitle, LandingTitle, LandingTitleList, LandingTitleUpdate } from '@/types';
import apiService from './ApiService';

class WebService {
    async getCurrentLandingTitle(): Promise<CurrentLandingTitle | null> {
        return apiService.get('web/current_landing_title');
    }

    async getLandingTitles(): Promise<LandingTitleList | null> {
        return apiService.get('web/landing_titles');
    }

    async getLandingTitle(id: number): Promise<LandingTitle | null> {
        return apiService.get(`web/landing_titles/${id}`);
    }

    async createLandingTitle(landingTitle: LandingTitleUpdate): Promise<LandingTitle | null> {
        return apiService.post('web/landing_titles', landingTitle);
    }

    async updateLandingTitle(landingTitleId: number, landingTitle: LandingTitleUpdate): Promise<LandingTitle | null> {
        return apiService.put(`web/landing_titles/${landingTitleId}`, landingTitle);
    }

    async deleteLandingTitle(landingTitleId: number): Promise<boolean | null> {
        const result = await apiService.delete(`web/landing_titles/${landingTitleId}`);
        return result !== null; // successful request returns empty string, unsuccessful returns null
    }
}

export default new WebService();
